exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports
exports.i(require("-!../../node_modules/css-loader/index.js??ref--6-1!../../../../postcss-loader/src/index.js??ref--6-2!../global/variables.css"), "");

// module
exports.push([module.id, ".text_b79 {\n  color: #1f2326;\n  color: var(--ring-text-color);\n}\n\n.info_5a9 {\n  color: #737577;\n  color: var(--ring-secondary-color);\n}\n", ""]);

// exports
exports.locals = {
	"text": "text_b79",
	"info": "info_5a9"
};